import React from "react";
import { Link } from "react-router-dom";
import "../styles/styles.css"; // Assure-toi que le chemin est correct

export default function Footer() {
  return (
    <footer className="wc-footer">
      <div className="container footer-grid">
        {/* Bloc 1 : Logo + droits */}
        <div className="footer-brand">
          {/* <img src="" alt="Wine Cella logo" /> */}
          <div>
            <h5>Ets EKLU</h5>
            <p>© {new Date().getFullYear()} Ets EKLU — Tous droits réservés</p>
          </div>
        </div>

        {/* Bloc 2 : Liens */}
        <div className="footer-links">
          <h6>Liens</h6>
          <ul>
            <li><Link to="/">Nos produits</Link></li>
            <li><Link to="/add">Ajouter un vin</Link></li>
            <li><Link to="/orders">Commandes</Link></li>
          </ul>
        </div>

        {/* Bloc 3 : Contact */}
        <div className="footer-contact">
          <h6>Contact</h6>
          <p><a href="mailto:contact@winecella.example">contact@ek.com</a></p>
          <p><a href="tel:+393895513136">+39 389 551 3136</a></p>
        </div>
      </div>
    </footer>
  );
}
